import { Slide, toast } from "react-toastify";

const error = (msg: string) => {
  toast.error(msg, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    transition: Slide,
  });
};

const success = (msg: string) => {
  toast.success(msg, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    transition: Slide,
  });
};

// Longer than error/success: used for "saved, but ..." notices the user needs time to read.
const warning = (msg: string) => {
  toast.warning(msg, {
    position: "top-center",
    autoClose: 8000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    transition: Slide,
  });
};

const info = (msg: string) => {
  toast.info(msg, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    transition: Slide,
  });
};

export const snack = { error, success, warning, info };
